/*
Sohel 01/05/2022 3075154998 Added drag and Drop functionality
Dilip 01/12/2023 2701315830 changed delete pop up title
manikanta  01/12/2023 2701315830,3075154998 changed delete pop up message
manikanta 01/13/2023 2701315830,3075154998 Fixed record identifier validations
Sohel 01/22/2023 2698951347 number field added min number props
Ravi 01/27/2023 2701315830,3075154998 fixed tooltip issue
Ravi 05/31/2023 2701315830,3075154998 changed delete popup message
Ravi 05/31/2023 2701315830,3075154998 changed delete popup message
Akhila 06/12/2023 2701315830 added role access
*/
import React, {useState} from 'react';
import {withField} from '../../DataManagerRecord/AddDataManagerRecord/RecordFormatFieldsComponents/withField';
import {Tooltip, IconButton, TextField} from '@material-ui/core';
import {DeleteOutlined} from '@material-ui/icons';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {ErrorTooltip} from '../../../../../components/Tooltips';
import {Draggable} from 'react-beautiful-dnd';
function GroupRecord(props) {
  const {
    name,
    setFieldValue,
    errors,
    value,
    index,
    values,
    dmArrayHelpers,
    fixedLength,
    exportRecordGroupAccess,
    importRecordGroupAccess,
    editExisting,
  } = props;
  const [isDelete, setIsDelete] = useState(false);
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleConfirmDelete = () => {
    dmArrayHelpers.current.remove(index);
    const data = [...values.groupRecords]?.filter(
      (i) => i.recordCode !== values?.groupRecords[index]?.recordCode,
    );
    setFieldValue('groupRecords', data);
    setIsDelete(false);
  };
  return (
    <>
      <Draggable key={index} draggableId={'draggable-' + index} index={index}>
        {(provided) => (
          <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <td className="recFormat-col recFormat-center">
              <Tooltip title="Delete">
                <IconButton
                  disabled={
                    editExisting &&
                    (!exportRecordGroupAccess?.edit || !importRecordGroupAccess?.edit)
                  }
                  onClick={() => setIsDelete(true)}
                >
                  <DeleteOutlined />
                </IconButton>
              </Tooltip>
            </td>
            <td className="recFormat-col global-field-textfields">{index + 1}</td>
            <td className="recFormat-col global-field-textfields">
              <ErrorTooltip
                title={
                  errors &&
                  errors.groupRecords &&
                  errors.groupRecords[index] &&
                  errors.groupRecords[index].recordIdentifier ?
                    errors.groupRecords[index].recordIdentifier :
                    ''
                }
              >
                <TextField
                  margin="dense"
                  type="text"
                  variant="outlined"
                  placeholder={`Record Identifier`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name={name + '.recordIdentifier'}
                  value={value.recordIdentifier}
                  error={
                    errors &&
                    errors.groupRecords &&
                    errors.groupRecords[index] &&
                    errors.groupRecords[index].recordIdentifier
                  }
                  onChange={(e) => {
                    setFieldValue(name + '.recordIdentifier', e.target.value);
                  }}
                />
              </ErrorTooltip>
            </td>
            {fixedLength === 'Y' && (
              <>
                <td className="recFormat-col global-field-textfields">
                  <TextField
                    margin="dense"
                    type="number"
                    variant="outlined"
                    placeholder={`Sub Identifier Start`}
                    inputProps={{
                      min: 0,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name={name + '.subStart'}
                    value={value.subStart}
                    onChange={(e) => {
                      setFieldValue(name + '.subStart', e.target.value);
                    }}
                  />
                </td>
                <td className="recFormat-col global-field-textfields">
                  <TextField
                    margin="dense"
                    type="number"
                    variant="outlined"
                    placeholder={`Sub Identifier Length`}
                    inputProps={{
                      min: 0,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name={name + '.subLength'}
                    value={value.subLength}
                    onChange={(e) => {
                      setFieldValue(name + '.subLength', e.target.value);
                    }}
                  />
                </td>
              </>
            )}
            {fixedLength === 'N' && (
              <td className="recFormat-col global-field-textfields">
                <TextField
                  margin="dense"
                  type="number"
                  variant="outlined"
                  placeholder={`Sub Identifier Position`}
                  inputProps={{
                    min: 0,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name={name + '.subPosition'}
                  value={value.subPosition}
                  onChange={(e) => {
                    setFieldValue(name + '.subPosition', e.target.value);
                  }}
                />
              </td>
            )}
            <td className="recFormat-col global-field-textfields">
              <TextField
                margin="dense"
                type="text"
                variant="outlined"
                placeholder={`Sub Identifier Value`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={name + '.subValue'}
                value={value.subValue}
                onChange={(e) => {
                  setFieldValue(name + '.subValue', e.target.value);
                }}
              />
            </td>
            <td className="recFormat-col global-field-textfields">{value.recordCode}</td>
            <td className="recFormat-col global-field-textfields">{value.recordDescription}</td>
          </tr>
        )}
      </Draggable>

      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Record"
        value={`Are you sure you want to delete the ${value?.recordCode} Record ?`}
        handleSubmit={handleConfirmDelete}
      />
    </>
  );
}
export default withField(GroupRecord);
